import { omitBy } from "lodash";

import { LoadedDestinationInfo } from "@/types/global";
import { getAllSaasDestinations } from "@/hooks/useAllSaasDestinations";

interface DestinationConfigPayload {
  id: string;
  dest_type: string;
  name: string;
  connection_mode: "server" | "client";
  settings: Record<string, unknown>;
  has_baa: boolean;
  function_id: string | null;
  custom_label: string;
  enabled?: boolean;
}

export function destinationConfigPayload(
  loadedDestination: LoadedDestinationInfo,
  { settings = {}, ...updates }: Partial<DestinationConfigPayload>,
): DestinationConfigPayload {
  const allSaasDestinations = getAllSaasDestinations();
  const saasDestination = allSaasDestinations[loadedDestination.type_slug];

  const updatedSettings = omitBy(
    {
      ...loadedDestination.settings,
      ...settings,
    },
    (v) => v === "",
  );

  return {
    id: loadedDestination.id,
    dest_type: saasDestination.key,
    name: saasDestination.key,
    connection_mode: saasDestination.supportsServerSide
      ? "server"
      : saasDestination.connection_mode,
    settings: updatedSettings,
    has_baa: loadedDestination.has_baa,
    function_id:
      saasDestination.key === "Function" ? saasDestination.slug : null,
    custom_label: loadedDestination.custom_label || "",
    ...updates,
  };
}
